export default "__VITE_ASSET__DYFAklas__"